enum EventFlag {
	NEEDS_REVISION = 'NEEDS_REVISION',
	BLOCK = 'BLOCK',
	OTHER_PRACTICE = 'OTHER_PRACTICE',
}

export default EventFlag;
